// @noflow
/* global nsNew_ */
import moment from 'moment';
import { get } from 'lodash';
import { SourceType } from 'Common/models/franchise';
import PlayerManager from '../PlayerManager';
import { PlayerEvent } from '../../../player/utils';

class ComscoreManager extends PlayerManager {
  get enabled() {
    return !!this._videoMetadata.custom_attributes.comscore_enabled;
  }

  get events() {
    return {
      [PlayerEvent.SourceLoaded]: () => {
        if (this.sourceType === SourceType.SLING_DVR) {
          return;
        }
        this.initialize();
      },
      [PlayerEvent.Destroy]: () => {
        // need to refactor player to use sourceunloaded here
        this._streamingAnalytics.notifyEnd();
      },
      [PlayerEvent.StallStarted]: () => {
        this._streamingAnalytics.notifyBufferStart();
      },
      [PlayerEvent.StallEnded]: () => {
        this._streamingAnalytics.notifyBufferStop();
      },
      [PlayerEvent.Play]: playbackEvent => {
        this._streamingAnalytics.notifyPlay(playbackEvent.time * 1000);
      },
      [PlayerEvent.Paused]: playbackEvent => {
        this._streamingAnalytics.notifyPause(playbackEvent.time * 1000);
      },
      [PlayerEvent.PlaybackFinished]: () => {
        this._streamingAnalytics.notifyEnd();
      },
      [PlayerEvent.Seek]: seekEvent => {
        this._streamingAnalytics.notifySeekStart(seekEvent.position * 1000);
      },
    };
  }

  get assetMetadata() {
    const airing = (this._airing && this._airing.airing) || {};
    const networkDetails = (this._airing && this._airing.networkDetails) || {};
    return this.sourceType === SourceType.LIVE_LINEAR
      ? // TODO: Update all uses of this._franchise for something inside of this._airing.airing or this._airing.qvt
        {
          ns_st_ci: airing.content_identification?.echostar_id,
          ns_st_cl: airing.duration,
          ns_st_pu: networkDetails.name,
          ns_st_st: networkDetails.name,
          ns_st_pr: airing.name,
          ns_st_tpr: airing.content_identification?.series_id,
          ns_st_ep: airing.episode_title, // add episode name for shows, when we have content
          ns_st_ge: airing.genres.length ? airing.genres[0] : 'NA',
          ns_st_ct: 'vc13', // vc13 is Premium LiveLinear or vc12 is PremiumVOD
          ns_st_ddt: moment(airing.original_air_date).format('YYYY-MM-DD'),
          ns_st_pn: 1, // only 1 segment for est
          ns_st_tp: 1, // only 1 segment for est
          ns_st_ce: 1,
          c3: 'DANY',
          c4: get(this._videoMetadata, 'content_provider_analytics.custom_metadata.C4', null),
          c6: get(this._videoMetadata, 'content_provider_analytics.custom_metadata.C6', null),
        }
      : {
          ns_st_ci: this._videoId,
          ns_st_cl: this._franchise.run_time * 1000,
          ns_st_pu: this._franchise.networks.length ? this._franchise.networks[0].name : '',
          ns_st_st: this._franchise.networks.length ? this._franchise.networks[0].name : '',
          ns_st_pr: this._franchise.name,
          ns_st_tpr: this._franchise.content_identification?.series_id,
          ns_st_ep: this._franchise.name, // add episode name for shows, when we have content
          ns_st_ge: this._franchise.genres.length ? this._franchise.genres[0] : 'NA',
          ns_st_ct: 'vc12', // vc13 is Premium LiveLinear or vc12 is PremiumVOD
          // ns_st_ddt: moment(this._franchise.releaseDate).format('YYYY-MM-DD'),
          ns_st_ddt: this._franchise.release_year,
          ns_st_pn: 1, // only 1 segment for est
          ns_st_tp: 1, // only 1 segment for est
          ns_st_ce: 1,
          c3: 'DANY',
          c4: get(this._videoMetadata, 'content_provider_analytics.custom_metadata.C4', null),
          c6: get(this._videoMetadata, 'content_provider_analytics.custom_metadata.C6', null),
        };
  }

  initialize() {
    this._streamingAnalytics = new nsNew_.StreamingAnalytics({
      publisherId: this._videoMetadata.custom_attributes.comscore_partner_id,
    });
    this._streamingAnalytics.createPlaybackSession();
    this._streamingAnalytics.getPlaybackSession().setAsset(this.assetMetadata);
  }
}

export default ComscoreManager;
